import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useParams } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import TomatoPage from './pages/TomatoPage';
import ChilliPage from './pages/ChilliPage';
import BrinjalPage from './pages/BrinjalPage';
import WatermelonPage from './pages/WatermelonPage';
import MuskmelonPage from './pages/MuskmelonPage';
import BhendiPage from './pages/BhendiPage';
import PumpkinPage from './pages/PumpkinPage';
import CucumberPage from './pages/CucumberPage';
import RidgeGourdPage from './pages/RidgeGourdPage';
import BottleGourdPage from './pages/BottleGourdPage';
import BitterGourdPage from './pages/BitterGourdPage';
import SpongeGourdPage from './pages/SpongeGourdPage';
import CabbagePage from './pages/CabbagePage';
import OnionPage from './pages/OnionPage';
import RadishPage from './pages/RadishPage';
import SweetCornPage from './pages/SweetCornPage';
import CarrotPage from './pages/CarrotPage';
import CapsicumPage from './pages/CapsicumPage';
import DlichosPage from './pages/DlichosPage';
import YardLongBeanPage from './pages/YardLongBeanPage';
import FrenchBeansPage from './pages/FrenchBeansPage';
import PoleBeansPage from './pages/PoleBeansPage';
import ClusterBeansPage from './pages/ClusterBeansPage';
import MarigoldPage from './pages/MarigoldPage';
import PapayaPage from './pages/PapayaPage';
import AshGourdPage from './pages/AshGourdPage';
import CorianderPage from './pages/CorianderPage';
import PalakPage from './pages/PalakPage';
import ProductCategoryPage from './pages/ProductCategoryPage';
import ResearchAndDevelopment from './pages/ResearchAndDevelopment';
import SeedProduction from './pages/SeedProduction';
import SeedProcessingQuality from './pages/SeedProcessingQuality';
import GalleryPhotosPage from './pages/GalleryPhotosPage';
import GalleryVideosPage from './pages/GalleryVideosPage';
import './App.css';
import './index.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
}

function ProductVarietyRoute() {
  const { category } = useParams();

  const routeMap = {
    tomato: TomatoPage,
    chilli: ChilliPage,
    brinjal: BrinjalPage,
    watermelon: WatermelonPage,
    muskmelon: MuskmelonPage,
    bhendi: BhendiPage,
    pumpkin: PumpkinPage,
    cucumber: CucumberPage,
    ridgegourd: RidgeGourdPage,
    bottlegourd: BottleGourdPage,
    bittergourd: BitterGourdPage,
    spongegourd: SpongeGourdPage,
    cabbage: CabbagePage,
    onion: OnionPage,
    radish: RadishPage,
    sweetcorn: SweetCornPage,
    carrot: CarrotPage,
    capsicum: CapsicumPage,
    dolichos: DlichosPage,
    yardlongbean: YardLongBeanPage,
    frenchbeans: FrenchBeansPage,
    polebeans: PoleBeansPage,
    clusterbeans: ClusterBeansPage,
    marigold: MarigoldPage,
    papaya: PapayaPage,
    ashgourd: AshGourdPage,
    coriander: CorianderPage,
    palak: PalakPage,
  };

  const ProductPage = routeMap[String(category || '').toLowerCase()];

  if (!ProductPage) {
    return <ProductCategoryPage />;
  }

  return <ProductPage />;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-shell">
        <Header />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products/tomato" element={<TomatoPage />} />
            <Route path="/products/chilli" element={<ChilliPage />} />
            <Route path="/products/brinjal" element={<BrinjalPage />} />
            <Route path="/products/watermelon" element={<WatermelonPage />} />
            <Route path="/products/muskmelon" element={<MuskmelonPage />} />
            <Route path="/products/bhendi" element={<BhendiPage />} />
            <Route path="/products/pumpkin" element={<PumpkinPage />} />
            <Route path="/products/cucumber" element={<CucumberPage />} />
            <Route path="/products/ridgegourd" element={<RidgeGourdPage />} />
            <Route path="/products/bottlegourd" element={<BottleGourdPage />} />
            <Route path="/products/bittergourd" element={<BitterGourdPage />} />
            <Route path="/products/spongegourd" element={<SpongeGourdPage />} />
            <Route path="/products/cabbage" element={<CabbagePage />} />
            <Route path="/products/onion" element={<OnionPage />} />
            <Route path="/products/radish" element={<RadishPage />} />
            <Route path="/products/sweetcorn" element={<SweetCornPage />} />
            <Route path="/products/carrot" element={<CarrotPage />} />
            <Route path="/products/capsicum" element={<CapsicumPage />} />
            <Route path="/products/dolichos" element={<DlichosPage />} />
            <Route path="/products/yardlongbean" element={<YardLongBeanPage />} />
            <Route path="/products/frenchbeans" element={<FrenchBeansPage />} />
            <Route path="/products/polebeans" element={<PoleBeansPage />} />
            <Route path="/products/clusterbeans" element={<ClusterBeansPage />} />
            <Route path="/products/marigold" element={<MarigoldPage />} />
            <Route path="/products/papaya" element={<PapayaPage />} />
            <Route path="/products/ashgourd" element={<AshGourdPage />} />
            <Route path="/products/coriander" element={<CorianderPage />} />
            <Route path="/products/palak" element={<PalakPage />} />
            <Route path="/products/:category/:varietySlug" element={<ProductVarietyRoute />} />
            <Route path="/products/:category" element={<ProductCategoryPage />} />
            <Route path="/r-and-d" element={<ResearchAndDevelopment />} />
            <Route path="/seed-production" element={<SeedProduction />} />
            <Route path="/seed-processing-quality" element={<SeedProcessingQuality />} />
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gallery/photos" element={<GalleryPhotosPage />} />
            <Route path="/gallery/videos" element={<GalleryVideosPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
